import { Outlet } from "react-router-dom";
import BottomNav from "./BottomNav";
import LegalFooter from "./LegalFooter";

export default function AppShell() {
  return (
    <div className="min-h-screen bg-background text-foreground md:flex" data-testid="app-shell">
      <BottomNav />
      <main className="flex-1 pb-20 md:pb-0 md:pt-0 flex flex-col">
        <div className="max-w-2xl mx-auto px-5 py-6 md:py-10 w-full flex-1">
          <Outlet />
        </div>
        <LegalFooter />
      </main>
    </div>
  );
}
